<template>
    <div class="d-flex gap-3 mb-2">
        <template v-if="title">
            <div class="flex-nowrap title col-7 col-md-4 col-lg-3"  :class="optional_title_class">{{ title }}</div>
        </template>
        <div class="flex-grow-1">
            <span class="fs-5 fw-bold me-2" :class="optional_text_class">{{ text }}</span>
            <small class="text-muted" :class="optional_unit_class">{{ unit }}</small>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConclusionRow',
    props: {
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '0',
        },
        unit: {
            type: String,
            default: '円',
        },
        optional_title_class: {
            type: String,
            default: ''
        },
        optional_text_class: {
            type: String,
            default: ''
        },
        optional_unit_class: {
            type: String,
            default: ''
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .title { background-color: #e9ecef; padding: .5rem 0; text-align: center; font-weight: bold; font-size: .8rem; }
</style>
